var codeblock_default = {
  "blockStyleSpacing": "MMpe-",
  "codeBlock": "_1RpXx MMpe-",
  "renderedInTable": "dNQlV"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
